module.exports = __webpack_public_path__ + "img/5-3.13507555.svg";